module.exports = __webpack_public_path__ + "img/6087369.29a95aab.jpg";